import { useState, useEffect } from 'react';

export default function usePWAInstall() {
  const [installEvent, setInstallEvent] = useState(null);
  const [isInstalled, setIsInstalled]   = useState(false);
  const [isIOS, setIsIOS]               = useState(false);
  const [isIOSSafari, setIsIOSSafari]   = useState(false);

  useEffect(() => {
    // Already installed as PWA?
    const standalone = window.matchMedia('(display-mode: standalone)').matches
      || window.navigator.standalone === true;
    setIsInstalled(standalone);

    // iOS detection
    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const safari = /safari/i.test(navigator.userAgent) && !/chrome/i.test(navigator.userAgent);
    setIsIOS(ios);
    setIsIOSSafari(ios && safari);

    // Android / Chrome install prompt
    const handler = e => { e.preventDefault(); setInstallEvent(e); };
    window.addEventListener('beforeinstallprompt', handler);

    // Track if user installs via the prompt
    window.addEventListener('appinstalled', () => setIsInstalled(true));

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const triggerInstall = async () => {
    if (!installEvent) return false;
    installEvent.prompt();
    const { outcome } = await installEvent.userChoice;
    if (outcome === 'accepted') setIsInstalled(true);
    setInstallEvent(null);
    return outcome === 'accepted';
  };

  const canInstall = !isInstalled && (!!installEvent || isIOSSafari);

  return { canInstall, isInstalled, isIOS, isIOSSafari, triggerInstall };
}
